import { memo } from 'react';
import { Title } from 'src/components';

interface IProps {
    title: string;
}

export function ContentTitle({ title }: IProps) {
    return <Title renderAs="h3">{title}</Title>;
}

export default memo(ContentTitle);
